import * as React from 'react';
import { SingleOptionPanel } from './options-panel/single-option-panel';
import { PanelsProps } from './types';
import { sfNames, sfParameters } from 'app/components/access-panel/sf-names';
import { manageOptionsUserGroup } from 'app/area/shared/manage-options';
import { AdminPaperTopPanel } from 'app/area/administration/edit/components';

export const AccessToAdministrateUserGroup = (props: PanelsProps) => {
  const { translation, readOnly, data, formComponent, formValues, endpoints, validation,
    roleSelected, roleBasedData, fetchingRoleBasedData, accessData,
    clearValueInStore, clearValidation, updateAccessData } = props;

  return <AdminPaperTopPanel title={translation.access_to_administrate_user_group}>
    <SingleOptionPanel
      readOnly={readOnly}
      translation={translation}
      initialValue={data?.accessToUserGroups}

      roleSelected={roleSelected}
      roleValue={roleBasedData && roleBasedData.accessToUserGroups}
      accessData={accessData && accessData.accessToUserGroups}
      updateAccessData={updateAccessData}
      fetchingRoleValue={fetchingRoleBasedData}

      formComponent={formComponent}
      formValues={formValues}
      valueName={sfParameters.subset}
      formName={sfNames.accessToUserGroups}
      validation={validation && validation[sfNames.accessToUserGroups]}
      valueOptionsEndpoint={endpoints.accessToUserGroups}
      valueLabel={translation.user_group}
      panelLabel={translation.user_groups}
      addButtonText={translation.add_user_group_button_text}
      displaySelectAll={true}
      clearValueInStore={clearValueInStore}
      clearValidation={clearValidation}

      extraFooterButton={manageOptionsUserGroup(translation.manage_options)}
    />
  </AdminPaperTopPanel>;
};
